import React from 'react';
import { Card, Row, Col, Typography, Divider, Tag, Timeline } from 'antd';
import { 
  ExperimentOutlined, 
  BarChartOutlined, 
  DatabaseOutlined,
  BulbOutlined,
  CheckCircleOutlined
} from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const WaterResourceModelIntro = () => {
  return (
    <div style={{ padding: '20px 0' }}>
      {/* 系统概述 */}
      <Card style={{ marginBottom: '24px' }}>
        <Title level={3} style={{ color: '#1890ff', marginBottom: '16px' }}>
          <ExperimentOutlined style={{ marginRight: '8px' }} />
          水资源配置优化模型系统
        </Title>
        <Paragraph style={{ fontSize: '16px', lineHeight: '1.6' }}>
          本系统基于多目标优化理论，构建了区域水资源配置优化模型，通过数学建模和算法求解，
          实现水资源在不同城市、不同产业间的最优分配，为区域水资源管理决策提供科学支撑。
        </Paragraph>
        
        <Row gutter={[16, 16]} style={{ marginTop: '20px' }}>
          <Col xs={24} sm={12} md={6}>
            <div style={{ textAlign: 'center', padding: '16px' }}>
              <DatabaseOutlined style={{ fontSize: '32px', color: '#52c41a', marginBottom: '8px' }} />
              <div style={{ fontWeight: 'bold' }}>多维数据</div>
              <div style={{ color: '#666', fontSize: '12px' }}>城市×产业×时间</div>
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div style={{ textAlign: 'center', padding: '16px' }}>
              <BulbOutlined style={{ fontSize: '32px', color: '#1890ff', marginBottom: '8px' }} />
              <div style={{ fontWeight: 'bold' }}>智能优化</div>
              <div style={{ color: '#666', fontSize: '12px' }}>多目标求解算法</div>
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div style={{ textAlign: 'center', padding: '16px' }}>
              <BarChartOutlined style={{ fontSize: '32px', color: '#722ed1', marginBottom: '8px' }} />
              <div style={{ fontWeight: 'bold' }}>对比分析</div>
              <div style={{ color: '#666', fontSize: '12px' }}>优化vs实际</div>
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div style={{ textAlign: 'center', padding: '16px' }}>
              <CheckCircleOutlined style={{ fontSize: '32px', color: '#f5222d', marginBottom: '8px' }} />
              <div style={{ fontWeight: 'bold' }}>决策支持</div>
              <div style={{ color: '#666', fontSize: '12px' }}>科学配置方案</div>
            </div>
          </Col>
        </Row>
      </Card>

      {/* 模型体系 */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card title="模型体系架构" style={{ height: '100%' }}>
            <Timeline
              items={[
                {
                  color: 'blue',
                  children: (
                    <div>
                      <Text strong>模型1 - 五城区三产业模型</Text>
                      <br />
                      <Text type="secondary">适用于中小规模区域，涵盖生活、工业、农业用水</Text>
                      <div style={{ marginTop: '8px' }}>
                        <Tag color="green">惠州</Tag>
                        <Tag color="green">深圳</Tag>
                        <Tag color="green">东莞</Tag>
                        <Tag color="green">河源</Tag>
                        <Tag color="green">增城</Tag>
                      </div>
                    </div>
                  )
                },
                {
                  color: 'green',
                  children: (
                    <div>
                      <Text strong>模型2 - 七城区四产业模型</Text>
                      <br />
                      <Text type="secondary">中等规模区域，增加生态用水考量</Text>
                      <div style={{ marginTop: '8px' }}>
                        <Tag color="blue">梅州</Tag>
                        <Tag color="blue">河源</Tag>
                        <Tag color="blue">韶关</Tag>
                        <Tag color="blue">惠州</Tag>
                        <Tag color="blue">广州</Tag>
                        <Tag color="blue">东莞</Tag>
                        <Tag color="blue">深圳</Tag>
                      </div>
                    </div>
                  )
                },
                {
                  color: 'red',
                  children: (
                    <div>
                      <Text strong>模型3 - 九城区四产业模型</Text>
                      <br />
                      <Text type="secondary">大规模区域综合优化，全产业覆盖</Text>
                      <div style={{ marginTop: '8px' }}>
                        <Tag color="purple">佛山</Tag>
                        <Tag color="purple">江门</Tag>
                        <Tag color="purple">中山</Tag>
                        <Tag color="purple">珠海</Tag>
                        <Tag color="purple">惠州</Tag>
                        <Tag color="purple">广州</Tag>
                        <Tag color="purple">东莞</Tag>
                        <Tag color="purple">深圳</Tag>
                        <Tag color="purple">南沙</Tag>
                      </div>
                    </div>
                  )
                }
              ]}
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card title="产业用水分类" style={{ marginBottom: '16px' }}>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <div style={{ padding: '16px', background: '#f6ffed', borderRadius: '6px', marginBottom: '12px' }}>
                  <div style={{ fontWeight: 'bold', color: '#52c41a', marginBottom: '4px' }}>
                    LIV - 生活用水
                  </div>
                  <div style={{ fontSize: '12px', color: '#666' }}>
                    城镇居民日常用水需求
                  </div>
                </div>
                <div style={{ padding: '16px', background: '#f0f5ff', borderRadius: '6px' }}>
                  <div style={{ fontWeight: 'bold', color: '#1890ff', marginBottom: '4px' }}>
                    IND - 工业用水
                  </div>
                  <div style={{ fontSize: '12px', color: '#666' }}>
                    制造业生产用水需求
                  </div>
                </div>
              </Col>
              <Col span={12}>
                <div style={{ padding: '16px', background: '#fff7e6', borderRadius: '6px', marginBottom: '12px' }}>
                  <div style={{ fontWeight: 'bold', color: '#fa8c16', marginBottom: '4px' }}>
                    AGR - 农业用水
                  </div>
                  <div style={{ fontSize: '12px', color: '#666' }}>
                    农田灌溉和农业生产用水
                  </div>
                </div>
                <div style={{ padding: '16px', background: '#f9f0ff', borderRadius: '6px' }}>
                  <div style={{ fontWeight: 'bold', color: '#722ed1', marginBottom: '4px' }}>
                    ECO - 生态用水
                  </div>
                  <div style={{ fontSize: '12px', color: '#666' }}>
                    生态环境维护用水需求
                  </div>
                </div>
              </Col>
            </Row>
          </Card>

          <Card title="优化目标" size="small">
            <ul style={{ paddingLeft: '20px', margin: 0 }}>
              <li style={{ marginBottom: '8px' }}>
                <Text strong>经济效益最大化：</Text>
                <Text type="secondary">提高水资源利用效率</Text>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <Text strong>社会效益优化：</Text>
                <Text type="secondary">保障基本用水需求</Text>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <Text strong>环境效益兼顾：</Text>
                <Text type="secondary">维护生态用水底线</Text>
              </li>
              <li>
                <Text strong>公平性原则：</Text>
                <Text type="secondary">区域间用水均衡发展</Text>
              </li>
            </ul>
          </Card>
        </Col>
      </Row>

      <Divider />

      {/* 技术特色 */}
      <Card title="技术特色与创新点">
        <Row gutter={[24, 16]}>
          <Col xs={24} md={8}>
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <div style={{ 
                width: '60px', 
                height: '60px', 
                background: '#e6f7ff', 
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px'
              }}>
                <ExperimentOutlined style={{ fontSize: '24px', color: '#1890ff' }} />
              </div>
              <Title level={4}>多目标优化</Title>
              <Paragraph type="secondary">
                采用改进遗传算法求解多目标优化问题，平衡经济、社会、环境效益
              </Paragraph>
            </div>
          </Col>
          <Col xs={24} md={8}>
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <div style={{ 
                width: '60px', 
                height: '60px', 
                background: '#f6ffed', 
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px'
              }}>
                <DatabaseOutlined style={{ fontSize: '24px', color: '#52c41a' }} />
              </div>
              <Title level={4}>动态建模</Title>
              <Paragraph type="secondary">
                考虑不同年份用水需求变化，支持多时间尺度的动态优化分析
              </Paragraph>
            </div>
          </Col>
          <Col xs={24} md={8}>
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <div style={{ 
                width: '60px', 
                height: '60px', 
                background: '#fff1f0', 
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px'
              }}>
                <BarChartOutlined style={{ fontSize: '24px', color: '#f5222d' }} />
              </div>
              <Title level={4}>可视化分析</Title>
              <Paragraph type="secondary">
                提供直观的图表对比分析，支持决策者快速理解优化结果
              </Paragraph>
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default WaterResourceModelIntro;